import api from './api';

export interface Notification {
  id: string;
  title: string;
  message: string;
  priority: 'low' | 'medium' | 'high';
  color?: string;
  icon?: string;
  sent_at: string;
  expires_at?: string;
  is_read: boolean;
  read_at?: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  total: number;
  unread_count: number;
}

export const notificationApi = {
  // ─── GET NOTIFICATIONS ──────────────────────────────────────────────────
  // ✅ includeRead: true = show all notifications, false = only unread
  getNotifications: async (limit: number = 20, includeRead: boolean = true) => {
    const response = await api.get('/v1/notifications', {
      params: { limit, include_read: includeRead }
    });
    return response.data;
  },

  // ─── GET UNREAD COUNT ──────────────────────────────────────────────────
  getUnreadCount: async () => {
    const response = await api.get('/v1/notifications/unread/count');
    return response.data;
  },

  // ─── MARK NOTIFICATION AS READ ─────────────────────────────────────────
  markAsRead: async (notificationId: string) => {
    const response = await api.put(`/v1/notifications/${notificationId}/read`);
    return response.data;
  },

  // ─── MARK ALL AS READ ──────────────────────────────────────────────────
  markAllAsRead: async () => {
    const response = await api.post('/v1/notifications/mark-all-read');
    return response.data;
  },
};

export default notificationApi;